<template>
    <b-row class="justify-content-center">
        <b-col md="6">
            <b-card>
                <b-form v-on:submit.prevent>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group
                            label="Division Name"
                            label-for="divisions"
                            >
                                <b-form-input
                                    id="divisions"
                                    placeholder="Division Name"
                                    v-model="form.divisions"
                                    required
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group
                            label="Organization"
                            label-for="organizations"
                            >
                                <v-select
                                id="organizations"
                                v-model="selected"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="text"
                                :options="options"
                                placeholder="Select 1 Organization"
                                >
                                    <template #search="{attributes, events}">
                                        <input
                                        class="vs__search"
                                        :required="!selected"
                                        v-bind="attributes"
                                        v-on="events"
                                        />
                                    </template>
                                </v-select>
                                <!-- Selected: <strong>{{ selected }}</strong> -->
                            </b-form-group>
                        </b-col>

                        <!-- submit and reset -->
                        <b-col md="12" class="mt-2">
                            <b-button
                            v-if="permissions.includes('division-update')"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            type="submit"
                            variant="primary"
                            class="mr-1"
                            @click="updateDivision()"
                            >
                            Update
                            </b-button>
                            <b-button
                            v-if="permissions.includes('division-delete')"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            type="submit"
                            variant="danger"
                            class="mr-1"
                            @click="deleteDivisions()"
                            >
                            Delete
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {
    BFormSelect, BListGroupItem, BAvatar, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

export default {
    components: {
        ToastificationContent,
        vSelect,
        BFormSelect,
        BListGroupItem,
        BAvatar,
        BCard,
        BCardText,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BButton,
        draggable,
        Prism
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            form: {
                divisions: ''
            },
            selected: null,
            options: [],
            permissions: []
        }
    },
    created() {
        this.getAllPermissions()
        this.getDetails()
        this.getOrganizations()
    },
    methods: {
        getAllPermissions() {
            this.permissions = sessionStorage.getItem('permissions')
        },
        getDetails() {
            const id = this.$route.params.id
            this.$http
            .get('divisions/' +id)
            .then((response) => {
                this.form.divisions = response.data.data.name
                this.selected = {value: response.data.data.organization_id, text: response.data.data.organization_name}
                // console.log(response.data.data)
            }).catch((err) => {
                console.log(err.response)
            });
        },
        getOrganizations() {
            this.$http.get('organizations')
            .then(res => { 
                // this.options.push({value: null, text: 'Please select 1 organization'})
                
                var datas = res.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    this.options.push($data)
                }
                // console.log(this.options)
            });
        },
        updateDivision() {
            const id = this.$route.params.id
            // console.log(id);

            this.$http
            .post("divisions/"+id+"/update", {
                "name": this.form.divisions,
                "organization_id": this.selected.value
            })
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Success update Division',
                        variant: 'success',
                    },
                })
                location.href = "/master/divisions"
                // console.log(response.data.data)
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
        deleteDivisions() {
            const id = this.$route.params.id
            this.$http
            .post("divisions/"+id+"/delete")
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Division has been deleted',
                        variant: 'danger',
                    },
                })
                location.href = "/master/divisions"
                console.log(response.data.data)
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                console.log(errors.response)
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>